module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/de-11d88d2b77e6abe5ebb1a7264ad57268.svg";